export default __webpack_public_path__ + "static/heart-795674e0aa5e40bb1b920181b88bef17.png";